import * as React from "react";
import {
  Image,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FlatList, ScrollView } from "react-native-gesture-handler";
import Tag from "./Tag";


export default class TrendingButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hovering: false
    };
  }

  editText = (text, width, height) => {
    let paragraphToCardRatio = 0.2;
    let lineHeight = 17.5;

    //67 characters for a width of 460
    let maxParagraphHeight = paragraphToCardRatio * height;
    let charactersPerLine = (65/460) * width;
    let numLines = Math.ceil(text.length/charactersPerLine);

    // check if text size is too big
    if ((lineHeight * numLines) > maxParagraphHeight) {
      let maxCharacters = Math.floor(maxParagraphHeight/lineHeight) * charactersPerLine;
      return text.slice(0, maxCharacters-2) + "...";
    }else {
      return text;
    }
  }

  hoverButton = () => {
      this.setState({
        hovering: !this.state.hovering
      })
  };



  render() {
    let cardDimensions = {
      width: this.props.width ? this.props.width : 586,
      height: this.props.height ? this.props.height : 419
    };

    var properties = {
      shadowColor: "#000",
      shadowOffset: {
      width: 0,
      height: 0,
      },
      shadowOpacity: 1,
    }

    if (this.state.hovering) {
      properties = {
        shadowColor: "#000",
        shadowOffset: {
        width: 6,
        height: 6,
        },
        shadowOpacity: 1,
      }
    }

    return (
      <TouchableOpacity onPress={this.props.navigate} onMouseEnter={() => this.hoverButton()} onMouseLeave={() => this.hoverButton()}>
      <View style={[styles.main, {shadowColor: properties.shadowColor, shadowOffset: properties.shadowOffset, shadowOpacity: properties.shadowOpacity, width: cardDimensions.width, height: cardDimensions.height}]}>
        <View style={{flex: 1.1}}>
          <Image
            source={this.props.source}
            style={styles.mainImage}
          />
        </View>
        <View style={{flex: 1, justifyContent: "space-evenly", paddingLeft: '5%', paddingRight: '5%', paddingTop: '2%', paddingBottom: '2%'}}>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              height: "8%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={{
                fontFamily: "Avenir Next",
                fontWeight: '600',
                fontSize: 25
              }}
            >
              {this.props.title}
            </Text>
          </View>
          <View style={{width: "100%",alignItems: "center",justifyContent: "center"}}>
            <Text
              style={{
                fontFamily: "Avenir Next",
                fontWeight: '400',
                fontSize: 14,
                width: "100%"
              }}
            >
              {this.editText(this.props.description, cardDimensions.width, cardDimensions.height)}
            </Text>
          </View>
          <View style={styles.tagView}>
            <FlatList
              data={this.props.tags}
              renderItem={({ item }) => (
                <Tag title={item} />
              )}
              keyExtractor={item => item}
              horizontal={true}
              showsHorizontalScrollIndicator={false}
            />

            <View style={styles.supporterView}>
              <Image
                source={require("../assets/images/person.svg")}
                style={{width: "10%", height: "100%", resizeMode: "contain" }}
              />
              <Text
                style={{
                  fontFamily: "Avenir Next",
                  fontWeight: '400',
                  fontSize: 14,
                }}
              >
                {this.props.supporters} supporters
              </Text>
            </View>
          </View>
        </View>
      </View>
      </TouchableOpacity>
    );
  };
};

TrendingButton.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  item: {
    backgroundColor: '#f9c2ff',
    padding: 20,
    marginVertical: 8,
    marginHorizontal: 16,
    borderRadius: 30,
  },
  title: {
    fontSize: 32,
    color: 'white'
  },
  main: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    overflow: 'hidden',
    //borderRadius: 12,
    borderColor: "black",
    borderWidth: 1,
    marginLeft: 18,
    marginRight: 18,
    marginTop: 20,
    marginBottom: 20
  },
  mainImage: {
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  supporterView: {
    width: "50%",
    height: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
  },
  tagView: {
    width: "100%",
    height: "6.5%",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  }
});